// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.uninjury-addyear[data-v-7c88b4e8] {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
